import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import PasswordApi from 'apis/Password';
import { inputFocusHandler } from 'utils/userFormValidate';

import PasswordContainer from 'components/users/Password';
import 'assets/scss/components/password.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      loading: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ loading: true });

    const { email } = this.state;
    const { history } = this.props;
    let that = this;

    PasswordApi.reset(email)
      .then(function (response) {
        toast.success(() => {
          return (
            <div>
              <FontAwesomeIcon icon="check-circle" />
              Please check your email for reset password instruction
            </div>
          );
        });

        that.setState({ loading: false });

        setTimeout(
          function () {
            history.push('/login');
          }.bind(this),
          1300
        );
      })
      .catch(function (error) {
        const { response, message } = error;

        toast.error(() => {
          const errorMessage = response.status === 422 ? 'Email Not Found' : message;

          return (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              {errorMessage}
            </div>
          );
        });

        that.setState({ loading: false });

        console.log(error);
      });
  };

  render() {
    const { loading } = this.state;

    return (
      <PasswordContainer
        headerInstruction="Please enter your email address"
        loading={loading}
        buttonContent="Send Reset Email"
        handleSubmit={this.handleSubmit}
      >
        <FormGroup>
          <Label for="email">Email</Label>
          <Input
            id="email"
            name="email"
            placeholder="Email"
            onChange={e => this.onChange(e)}
            type="email"
            onBlur={inputFocusHandler}
            required
          />
          <div className="row error" id="emailError" />
        </FormGroup>
      </PasswordContainer>
    );
  }
}

ResetPassword.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/users/ResetPassword.js